import React, { useEffect, useState } from "react";
import  { useNavigate, Navigate } from 'react-router-dom'
import { baseUrl } from "../shared";
import '../pages/App.css';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Toggle } from './ui';

export function UpdateUser({ onClose }) {
    const close = onClose || (() => { window.location.href = '/admin'; });
    const [changed, setChanged] = useState(false);
    var [userEdit, setUserEdit] = useState({});
    var [modUser, setModUser] = useState({});
    // The picked id lives in its own state: userDetails() replaces modUser with
    // the fetched row, which has no selUserId, so binding the Select to
    // modUser.selUserId blanked it straight after every pick.
    const [selectedUserId, setSelectedUserId] = useState('');
    var [userList, setUserList] = useState([]);
    const [usersLoaded, setusersLoaded] = useState(false);
    const [userSelected, setUserSelected] = useState(false);
    var [nameKey, setNameKey] = useState();
    var [emailKey, setEmailKey] = useState();
    const navigate = useNavigate();

    const [loginStatus, setLoginStatus] = useState(false);
    const [updateUser] = useState(true);
    const [open, setOpen] = React.useState(false);
    const [successOpen, setSuccessOpen] = React.useState(false);
    const [failOpen, setFailOpen] = React.useState(false);
    const [message, setMessage] = useState('');

    const handleClose = () => {
      setOpen(false);
    };

    const handleFailClose = () => {
      setFailOpen(false);
    };

    const handleProceedClose = (e) => {
      userUpdate(e)
      setOpen(false);
    };

    const handleSuccessClose = () => {
      <Navigate to={'/admin/'} />
      {navigate(0)}
    }

    useEffect(()=> {
      if (!localStorage.getItem('token')) {
        setLoginStatus(false);
      } else {
        setLoginStatus(true);
      }
    },[]);

    useEffect(() => {
      if (usersLoaded === false ) {
      const url = baseUrl + 'user/list/';
        fetch(url, {
          method: 'GET',
          headers: {
              'username': localStorage.getItem('username'),
              'bToken': localStorage.getItem('bToken')
          }})
          .then((res) => {
            return res.json();
        }).then((json) => {
            console.log(json)
            setUserList(json);
            setusersLoaded(true);
        })
        .catch((err) => {
           console.log(err.message);
        });
      }
      })

    useEffect(()=> {
        console.log(changed);
        console.log('Selected User ',userEdit);
        console.log('Modified User ',modUser);
    });

    async function userUpdate(e) {
        e.preventDefault();
        const url = baseUrl+'user/update';
        await fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'username': localStorage.getItem('username'),
                'bToken': localStorage.getItem('bToken'),
                'selUserId': modUser.id
            },
            body: JSON.stringify(modUser),
        })
        .then((response) => response.json())
          .then((data) => {
            console.log(data)
            if( data.status === 200) {
            setMessage(data.message);
            setSuccessOpen(true);
            } else if (data.status === 401) {
              setMessage(data.message);
              setFailOpen(true);
            }
          })
          .catch((err) => {
            setMessage(err.message);
            setFailOpen(true);
          });
      }

    function userDetails(e) {
      const url = baseUrl+'user/details';
      fetch(url, {
          method: 'PATCH',
          headers: {
              'Content-Type': 'application/json',
              'username': localStorage.getItem('username'),
              'bToken': localStorage.getItem('bToken'),
              'selUserId': e
          },
          body: JSON.stringify(modUser),
      })
          .then((response) => {
              if (!response.ok) throw new Error('something went wrong');
              return response.json();
          })
          .then((data) => {
            setUserEdit(data[0]);
            setModUser(data[0]);
            setNameKey(`${Math.floor((Math.random() * 1000))}-min`);
            setEmailKey(`${Math.floor((Math.random() * 1000))}-min`);
          });
    }


    return (
      <div className="admin">
        <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Confirm Update User
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
        <DialogActions>
          <Button onClick={handleProceedClose}>Proceed</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
        <React.Fragment>
      <Dialog
        open={successOpen}
        onClose={handleSuccessClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSuccessClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
        <React.Fragment>
      <Dialog
        open={failOpen}
        onClose={handleFailClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFailClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

    { loginStatus && updateUser && localStorage.getItem('adminFunctions') === '1' ? (
        <Dialog open onClose={close} fullWidth maxWidth="sm">
          <DialogTitle>Update Existing User</DialogTitle>
          <DialogContent dividers>
          <FormControl
          margin="dense"
     fullWidth>
     <InputLabel shrink htmlFor="usernameTitle">
    Username
  </InputLabel>
        <Select
          label="Username"
          inputProps={{ id: 'usernameTitle' }}
          fullWidth
          displayEmpty
          value={selectedUserId}
          onChange={(e) => {
            setSelectedUserId(e.target.value);
            setUserSelected(true);
            setModUser({
              ...modUser,
              selUserId: e.target.value,
           });
            userDetails(e.target.value);
            }}>
            <MenuItem value="" disabled>Select Username to Modify</MenuItem>
          {
          userList.map((u) => (
            <MenuItem value={u.id} key={u.id}>{u.username}</MenuItem>
          ))
      }
  </Select>
     </FormControl>

     { userSelected ? (
      <>
      <Box>
        <TextField
          fullWidth
          required
          label="Company"
          key= {nameKey}
          value={modUser.company}
          onChange={(e) => {
            setChanged(true);
            setModUser({
               ...modUser,
               company: e.target.value,
            });
            }}
            />
            </Box>
        <Box>
         <TextField
        fullWidth
          margin="dense"
          id="name"
          label="Full Name"
          variant="outlined"
          key= {nameKey}
          value={modUser.fullName}
          type="text"
          onChange={(e) => {
            setChanged(true);
            setModUser({
               ...modUser,
               fullName: e.target.value,
            });
            }}
        />
     </Box>
        <Box>
         <TextField
        fullWidth
          margin="dense"
          id="email"
          label="E-Mail Address"
          key={emailKey}
          variant="outlined"
          defaultValue={modUser.emailAddress}
          type="text"
          onChange={(e) => {
            setChanged(true);
            setModUser({
               ...modUser,
               emailAddress: e.target.value,
            });
            }}
        />
     </Box>
     <Box sx={{ width: '100%', border: '1px solid var(--border)', borderRadius: 'var(--r-sm)', overflow: 'hidden', mt: 1, mb: 1 }}>
       {[
         { label: 'Can Use Admin Functions', key: 'adminFunctions' },
         { label: 'Can View Wallboard',      key: 'canViewWallboard' },
       ].map(({ label, key }, i, arr) => (
         <Box key={key} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 1, backgroundColor: i % 2 === 0 ? 'var(--surface-2)' : 'var(--surface)', borderBottom: i < arr.length - 1 ? '1px solid var(--border)' : 'none' }}>
           <Box component="span" sx={{ fontSize: '0.875rem', color: 'var(--text)', flex: 1 }}>{label}</Box>
           <Toggle checked={Boolean(modUser[key])} onChange={() => { setChanged(true); setModUser({ ...modUser, [key]: modUser[key] ? 0 : 1 }); }} />
         </Box>
       ))}
     </Box>
</>
      ) : null}
          </DialogContent>
          <DialogActions>
            <Button onClick={close}>Cancel</Button>
            <Button variant="contained" disabled={!changed} onClick={setOpen}>Update User</Button>
          </DialogActions>
        </Dialog>
        ) : null
      }
      </div>
    );
  }

export default UpdateUser
